import User from "./User";
import Project from "./Project";
import Schedule from "./Schedule";
import Rfq from "./Rfq";
import AdminUser from "./AdminUser";
import Dealer from "./Dealer";
import Contractor from "./Contractor";
import Architect from "./Architect";

const repositories = {
  user: User,
  project: Project,
  schedule: Schedule,
  rfq: Rfq,
  adminUser: AdminUser,
  dealer: Dealer,
  contractor: Contractor,
  architect: Architect
};

export const Factory = {
  get: name => repositories[name]
};
